import { Inject, Injectable } from '@angular/core';
import { APP_CONFIG, EnvironmentModel } from '@fh-client-interaction-frontends/fh-app-config';
import { HttpClient, HttpParams } from '@angular/common/http';
import { CpRefundsRequestModel, CpRefundsResponseModel } from '@fh-client-interaction-frontends/fh-client-portal-service';
import { map, Observable } from 'rxjs';
import { CpProviderRequestModel } from '../../helpers/objects/request/provider/cp-provider-request-model';
import { CpProviderModel } from '../../helpers/objects/dto/provider/cp-provider-model';

@Injectable({
  providedIn: 'root'
})
export class CpProvidersService {
  appConfig: EnvironmentModel = new EnvironmentModel();

  constructor(@Inject(APP_CONFIG) protected appConfigTemp: EnvironmentModel, private http: HttpClient) {
    this.appConfig = appConfigTemp;
  }

  getAll(request: CpProviderRequestModel): Observable<CpProviderModel[]> {
    const contract = atob(sessionStorage.getItem('contract')!);

    return this.http
      .post<any>(this.appConfig.api + 'contracts/' + encodeURIComponent(contract) + '/authorizations/providers', request)
      .pipe(map((response) => response.body.buildings as CpProviderModel[]));
  }
}
